export const RFX_NOTIFICATION_MGMT_QUERY_KEYS = {
	management: (rfxId: number) => ["rfx-notification-management", rfxId] as const,
} as const;

export const NOTIFICATION_CENTRE_QUERY_KEYS = {
	list: () => ["notification-centre-list"] as const,
	unreadCount: () => ["notification-centre-unread-count"] as const,
} as const;
